const skuFilter = {
    namespaced: true,
    state: {
        data: ""
    },
    mutations: {
        SET_DATA(state, sku) {
            state.data = sku;
        }
    },
    actions: {
        setData(context, data) {
            context.commit("SET_DATA", data);
        }
    },
    getters: {
        data: state => {
            return state.data;
        },
        toParams: state => {
            return [{ column: "sku", value: state.data }];
        }
    }
};

export default skuFilter;
